import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import DashboardLayout from './components/DashboardLayout';

// Public pages
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import PressReleaseDetail from './pages/PressReleaseDetail';
import ArticleDetail from './pages/ArticleDetail';

// Dashboard – User pages
import UserDashboard from './pages/dashboard/UserDashboard';
import AddPressRelease from './pages/dashboard/AddPressRelease';
import ViewPressReleases from './pages/dashboard/ViewPressReleases';
import AddGuestPost from './pages/dashboard/AddGuestPost';
import ViewGuestPosts from './pages/dashboard/ViewGuestPosts';
import PRPackages from './pages/dashboard/PRPackages';
import GuestPackages from './pages/dashboard/GuestPackages';
import MyTransactions from './pages/dashboard/MyTransactions';
import PRCredits from './pages/dashboard/PRCredits';
import GuestCredits from './pages/dashboard/GuestCredits';
import DashboardCompanies from './pages/dashboard/DashboardCompanies';
import MyProfile from './pages/dashboard/MyProfile';
import SupportTickets from './pages/dashboard/SupportTickets';

// Dashboard – Admin pages
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminPRPackages from './pages/admin/AdminPRPackages';
import AdminGuestPackages from './pages/admin/AdminGuestPackages';
import AdminPressReleases from './pages/admin/AdminPressReleases';
import AdminGuestPosts from './pages/admin/AdminGuestPosts';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/press-release/:id" element={<PressReleaseDetail />} />
          <Route path="/article/:id" element={<ArticleDetail />} />

          {/* Dashboard (authenticated) */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<UserDashboard />} />
            <Route path="press-release/add" element={<AddPressRelease />} />
            <Route path="press-releases" element={<ViewPressReleases />} />
            <Route path="guest-post/add" element={<AddGuestPost />} />
            <Route path="guest-posts" element={<ViewGuestPosts />} />
            <Route path="packages/pr" element={<PRPackages />} />
            <Route path="packages/guest" element={<GuestPackages />} />
            <Route path="transactions" element={<MyTransactions />} />
            <Route path="pr-credits" element={<PRCredits />} />
            <Route path="guest-credits" element={<GuestCredits />} />
            <Route path="companies" element={<DashboardCompanies />} />
            <Route path="profile" element={<MyProfile />} />
            <Route path="support" element={<SupportTickets />} />
          </Route>

          {/* Admin panel */}
          <Route path="/admin" element={<DashboardLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="packages/pr" element={<AdminPRPackages />} />
            <Route path="packages/guest" element={<AdminGuestPackages />} />
            <Route path="press-releases" element={<AdminPressReleases />} />
            <Route path="guest-posts" element={<AdminGuestPosts />} />
          </Route>

          {/* Legacy routes redirect */}
          <Route path="/create" element={<Navigate to="/dashboard/press-release/add" replace />} />
          <Route path="/create/press-release" element={<Navigate to="/dashboard/press-release/add" replace />} />
          <Route path="/create/article" element={<Navigate to="/dashboard/guest-post/add" replace />} />
          <Route path="/my-posts" element={<Navigate to="/dashboard/press-releases" replace />} />
          <Route path="/companies" element={<Navigate to="/dashboard/companies" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
